import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { ProfileService } from '../profile.service';
import { CommonService } from '../../../common-service/common.service';
import { LocalStorageService } from '../../../common-service/local-storage.service';
import { Router } from '@angular/router';
import { Utility } from '../../../common-service/utility';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {
  data: any[];
  username: any[];
  isLoading = false;
  @Input() sidebarId: string = "sidebar";

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)

  constructor(private classToggler: ClassToggleService,
    private _userService: ProfileService,
    private commonservices: CommonService,
    private _localStorageService: LocalStorageService,
    private router: Router,
    private utility: Utility,
  ) {
    super();
  }
  ngOnInit() {

    this._userService.getUserById();
    this._userService.onUserChange.subscribe((data: any) => {
      this.username = data;

    })
  }
  logout() {
    this._localStorageService.removeStorage('user_token')
    localStorage.clear()
    this.utility.showSuccess('Logout')
    this.router.navigateByUrl('/auth/login')
  }
}
